export default __webpack_public_path__ + "static/media/logos.cafee2d1.png";